// import { enviroments } from '@infrastructure/enviroments';
import { enviroments } from '@infrastructure/enviroments';
import { base } from '@service/base';
import { PageLimitFilter } from '@typings';

import { CouponDigital } from 'src/models';

const BASE_URL = enviroments.BASE_URL;

export async function getDigitalCoupons({
  page,
  limit,
  filter,
  order: ordered,
}: PageLimitFilter): Promise<CouponDigital.TCouponResponse> {
  let where = {};
  if (filter) {
    Object.keys(filter).forEach(key => {
      if (filter[key]) {
        where = {
          ...where,
          [key]: filter[key],
        };
      }
    });
  }

  const order = !ordered || ordered === '' ? '[id,DESC]' : ordered;

  const response = await base({
    baseURL: BASE_URL,
    url: `/coupon`,
    method: 'GET',
    params: {
      ...where,
      limit,
      page,
      order,
    },
  });

  return {
    count: response.data.total,
    rows: response.data.data,
  };
}
